import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import './Hearing.css';

const HearingProceedings = () => {
  const { hearings, setHearings, cases, setCases, addAuditLog } = useApp();
  const [selectedHearingId, setSelectedHearingId] = useState('');
  const [formData, setFormData] = useState({
    remarks: '',
    nextHearingDate: '',
    caseStatus: '',
  });

  const selectedHearing = hearings.find(h => h.id === selectedHearingId);
  const caseItem = cases.find(c => c.caseNumber === selectedHearing?.caseNumber);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!selectedHearingId) {
      alert('Please select a hearing first');
      return;
    }

    // Update hearing with proceedings
    setHearings(hearings.map(h => 
      h.id === selectedHearingId
        ? {
            ...h,
            status: 'Completed',
            remarks: formData.remarks,
            nextHearingDate: formData.nextHearingDate,
            proceedingsDate: new Date().toISOString(),
          }
        : h
    ));

    // Update case status if provided
    if (formData.caseStatus && caseItem) {
      setCases(cases.map(c => 
        c.id === caseItem.id
          ? { ...c, status: formData.caseStatus }
          : c
      ));
    }

    // Schedule next hearing if provided
    if (formData.nextHearingDate && caseItem) {
      const nextHearing = {
        id: Date.now().toString(),
        caseId: caseItem.id,
        caseNumber: caseItem.caseNumber,
        caseTitle: caseItem.caseTitle,
        hearingDate: formData.nextHearingDate,
        hearingTime: selectedHearing.hearingTime,
        courtId: selectedHearing.courtId,
        judgeId: selectedHearing.judgeId,
        courtName: selectedHearing.courtName,
        judgeName: selectedHearing.judgeName,
        benchName: selectedHearing.benchName,
        status: 'Scheduled',
        purpose: 'Next Hearing',
        createdAt: new Date().toISOString(),
      };
      setHearings([...hearings, nextHearing]);
    }

    addAuditLog('Hearing Proceedings Updated', `Proceedings updated for case ${selectedHearing?.caseNumber}`);
    
    setFormData({
      remarks: '',
      nextHearingDate: '',
      caseStatus: '',
    });
    setSelectedHearingId('');
  };

  return (
    <div className="hearing-container">
      <div className="hearing-header">
        <h1>📝 Hearing Proceedings</h1>
      </div>

      <div className="hearing-form-card">
        <h2>Select Hearing</h2>
        <div className="form-group">
          <select
            value={selectedHearingId}
            onChange={(e) => {
              setSelectedHearingId(e.target.value);
              const hearing = hearings.find(h => h.id === e.target.value);
              if (hearing) {
                setFormData({
                  remarks: hearing.remarks || '',
                  nextHearingDate: hearing.nextHearingDate || '',
                  caseStatus: caseItem?.status || '',
                });
              }
            }}
            className="case-select"
          >
            <option value="">Select a hearing</option>
            {hearings.filter(h => h.status === 'Scheduled' || h.status === 'Completed').map(h => (
              <option key={h.id} value={h.id}>
                {h.caseNumber} - {new Date(h.hearingDate).toLocaleDateString()} at {h.hearingTime} ({h.status})
              </option>
            ))}
          </select>
        </div>
      </div>

      {selectedHearingId && selectedHearing && (
        <div className="hearing-form-card">
          <h2>Hearing Details</h2>
          <div className="hearing-details">
            <div className="detail-item">
              <strong>Case:</strong> {selectedHearing.caseNumber} - {selectedHearing.caseTitle}
            </div>
            <div className="detail-item">
              <strong>Date:</strong> {new Date(selectedHearing.hearingDate).toLocaleDateString()}
            </div>
            <div className="detail-item">
              <strong>Time:</strong> {selectedHearing.hearingTime}
            </div>
            <div className="detail-item">
              <strong>Court:</strong> {selectedHearing.courtName}
            </div>
            <div className="detail-item">
              <strong>Judge:</strong> {selectedHearing.judgeName}
            </div>
            <div className="detail-item">
              <strong>Status:</strong> 
              <span className={`status-badge status-${selectedHearing.status.toLowerCase()}`}>
                {selectedHearing.status}
              </span>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              <div className="form-group full-width">
                <label>Judge Remarks *</label>
                <textarea
                  value={formData.remarks}
                  onChange={(e) => setFormData({...formData, remarks: e.target.value})}
                  rows="6"
                  placeholder="Enter judge remarks and proceedings details"
                  required
                />
              </div>

              <div className="form-group">
                <label>Update Case Status</label>
                <select
                  value={formData.caseStatus}
                  onChange={(e) => setFormData({...formData, caseStatus: e.target.value})}
                >
                  <option value="">Keep Current Status</option>
                  <option value="Pending">Pending</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Disposed">Disposed</option>
                </select>
              </div>

              <div className="form-group">
                <label>Next Hearing Date (if applicable)</label>
                <input
                  type="date"
                  value={formData.nextHearingDate}
                  onChange={(e) => setFormData({...formData, nextHearingDate: e.target.value})}
                />
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-primary">
                Save Proceedings
              </button>
            </div>
          </form>

          {selectedHearing.remarks && (
            <div className="previous-remarks">
              <h3>Previous Remarks</h3>
              <p>{selectedHearing.remarks}</p>
              {selectedHearing.nextHearingDate && (
                <p><strong>Next Hearing:</strong> {new Date(selectedHearing.nextHearingDate).toLocaleDateString()}</p>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default HearingProceedings;

